import StartConversation from 'components/organisms/teachers/modal_contents/start_conversation/StartConversation';
import { connect } from 'react-redux';
import * as ModalActions from 'reducers/modal';
const mapStateToProps = (state, props) => {
    return {
        myId: state.rootReducer.teachers.me.id,
    };
};
const enhancer = connect(mapStateToProps, {
    close: ModalActions.close,
});
export default enhancer(StartConversation);
